(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-currency-notice"] && !Shopify.designMode) return;
  try {
    (function () {
    // Currency the shopper actually sees. Ground truth first: the ISO code BUCKS
    // renders inside a price (e.g. "$66.99 USD"); then config/cache fallbacks.
    function code() {
      try {
        var m = document.querySelector('.buckscc-money');
        if (m) { var iso = (m.textContent || '').match(/\b([A-Z]{3})\b/); if (iso) return iso[1]; }
      } catch (e) {}
      try {
        var u = window.bucksCC && window.bucksCC.metaConfig && window.bucksCC.metaConfig.userCurrency;
        if (u) return u;
      } catch (e) {}
      try {
        var a = JSON.parse(localStorage.getItem('buckscc_auto_currency') || 'null');
        if (a && a.currency) return a.currency;
      } catch (e) {}
      return null;
    }

    function apply() {
      var notes = document.querySelectorAll('[data-cart-currency-notice]');
      if (!notes.length) return;
      var c = code();
      var show = !!c && c !== 'EUR';
      for (var i = 0; i < notes.length; i++) {
        notes[i].hidden = !show;
        if (show) {
          var t = notes[i].querySelector('[data-ccn-template]');
          if (t) {
            var txt = (t.getAttribute('data-ccn-template') || '').replace('[code]', c);
            if (t.textContent !== txt) t.textContent = txt;
          }
        }
      }
    }

    // BUCKS renders async: poll a while to catch the first paint.
    var tries = 0;
    var iv = setInterval(function () { apply(); if (tries++ > 80) clearInterval(iv); }, 300);

    // React to a currency switch and to cart morphing (BUCKS repaints .buckscc-money).
    if (!window.__ccnObserver) {
      try {
        var mo = new MutationObserver(function () { apply(); });
        mo.observe(document.body, { subtree: true, childList: true, characterData: true });
        window.__ccnObserver = mo;
      } catch (e) {}
    }

    document.addEventListener('DOMContentLoaded', apply);
    window.addEventListener('pageshow', apply);
  })();
  } catch(e) { console.error(e); }
})();

})();
